import { Component, OnInit } from '@angular/core';
import {Events} from "../../../framework/providers/events";
import {BusinessService} from "../../services/BusinessService";
import {AppSettings} from "../../conf/appSettings";


@Component({
  selector: 'app-sales',
  templateUrl: './sales.page.html',
  styleUrls: ['./sales.page.scss'],
})
export class SalesPage implements OnInit {

  public searchText: string;
  public settings: object;
    public options: object = {'hide_search':false};

  constructor(public events:Events, public businessService:BusinessService, public appSettings: AppSettings) { }

  ngOnInit() {
        this.settings = this.appSettings.getSettings('sales');
  }


    search() {
        // if (!this.searchText || this.searchText == '') return;
        // this.modelProvider.list('miniItem', {'search':this.searchText}).then((res)=>{
        //   this.models = res['models'];
        // })
        this.events.publish(this.options['prefix'] + '_updateItemsFilter', {'search': this.searchText});
    }

}
